import React from 'react';
import LinkElement from './LinkElement';
import './LoginButton.css';
import config from '../config/constants';

export default class LoginButton extends React.Component{
	
	static defaultProps = {
		href: `${config.PROTOCOL}://${config.DOMAIN}/login`,
		label: 'label'
	};
	
	render = () => {
		return (
			<div className="rcg-header">
				<div className="rcg-button-container">
					<LinkElement className="rcg-head-login" target="__blank" href={this.props.href} label={'Login'}/>
				</div>
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/LoginButton.js